
import { makeStyles, useTheme } from '@material-ui/core/styles';
export const useStyles = makeStyles(theme => ({
  wrapper: {
    margin: '30px 0',
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      flexDirection: 'column',
       alignItems: 'center',
      justifyContent: 'center',
      padding: '0 20px'
    }
  },
  title: {
    margin: '0 0 12px',
  },
  inputIndent: {
    marginBottom: '30px',
    [theme.breakpoints.down('sm')]: {
     
      padding: '0px 20px 0px 20px',
      alignItems: 'flex-center',
    }
  },
  row: {
    display: 'flex',
    flexWrap: 'wrap', 
    gap: '20px',  
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'flex-center',
   
    },
  },
  column: {
    width: '286px',
    flex: '1 1 auto',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      alignItems: 'flex-center',
      
      
    },
  },
  spaceBetween: {
    display: 'flex',
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]: {
      margin: '0px 20px 0px 20px',
      
    },
  },
  datePickerWrapper: {
    width: '247px',
    [theme.breakpoints.down('sm')]: {
      width: '90%',
    },
  },
  helpIcon: {
    fontSize: '19px',
    marginTop: '29px',
    color: '#182e3d',
    [theme.breakpoints.down('sm')]: {
      display: 'none', 
    },
  },
  timePicker: {
    width: '135px !important',
    marginBottom: '30px',
    [theme.breakpoints.down('sm')]: {
      width: '100% !important',
      margin: '0px 20px 20px 0px',
    },
  },
  labelWithHelpIcon: {
    display: 'flex',
    position: 'relative'
  },
  chipsHelpIcon: {
    position: 'absolute',
    fontSize: '18px',
    top: '-4px',
    marginLeft: '6px'
  },
  activityTypeWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  colorPaletteWrapper: {
    width: '285px',
    [theme.breakpoints.down('sm')]:{
      marginLeft: '0px',
      marginBottom: '20px'
    }
  },
  colorPalette: {
    position: 'relative',
    width: '285px',
    height: '35px',
    borderRadius: '3px',
    backgroundColor: '#E2EBF6',
  },
  editIconWrapper: {
    position: 'absolute',
    bottom: '0',
    right: '0',
    '&:hover': {
      cursor: 'pointer'
    },
    background: '#464646',
    height: '24px',


  },
  helpIconColor:{
    position: 'absolute',
    margin: '20px 0 0 10px'
  }    
}));
